import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import {
  REQUEST_KANBAN_BOARD_PERFORM_ACTION,
  TASK_STATUS_ACTIVE,
  TASK_STATUS_INACTIVE,
  TASK_STATUS_PLAN,
} from '../../constants';
import { Cell } from '../Cell';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { VBox } from '../../../../components/Box';
import { Checkbox } from '../../../../components/Checkbox';

const Container = styled.div``;

const DEFAULTS = {
  task_adm_out_1_cancel_exports: '0',
  task_adm_out_2_export_plates: '0',
  task_adm_out_3_german_letter: '0',
  task_adm_out_4_move_to_weeze: '0',
  task_adm_out_5_sales_release: '0',
};

const STATE = {
  approve: false,
  ...DEFAULTS,
};

/* eslint-disable react/prefer-stateless-function */
class ADM_OUT_0_tasksComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  generatePayload() {
    let fields = {};

    for (let name in this.state) {
      if (name.indexOf('task_') === 0) {
        fields[name] = this.state[name];
      }
    }

    console.dir(fields);
    debugger;

    return fields;
  }

  render01(name) {
    return (
      <Checkbox
        key={name}
        checked={this.state[name] == TASK_STATUS_ACTIVE}
        onChange={() => {
          this.setState({ [name]: this.state[name] != TASK_STATUS_ACTIVE ? TASK_STATUS_ACTIVE : TASK_STATUS_INACTIVE });
        }}
      >
        {this.lbl(`vehicle.property.${name}`)}
      </Checkbox>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    console.dir(this.state);
    return (
      <Modal onClose={this.reset.bind(this)} title={this.props.action.label}>
        <VehicleHeader vehicle={this.vehicle} />

        <VBox>
          <Well>{this.props.column.label} Voltooid?</Well>
          {_.map(DEFAULTS, (value, name) => [name, value])
            .filter(m => m)
            .map(pair => (
              <Checkbox
                key={pair[0]}
                checked={this.state[pair[0]] === '1'}
                onChange={this.setStateFn({ [pair[0]]: this.state[pair[0]] === '1' ? '0' : '1' })}
              >
                {this.lbl(`vehicle.property.${pair[0]}`)}
              </Checkbox>
            ))}
          <div>&nbsp;</div>
        </VBox>
        <ModalControls>
          <PerformActionButton
            payload={this.generatePayload()}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.reset.bind(this)}
          />
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton onClick={this.setStateFn({ approve: !this.state.approve })}>
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

ADM_OUT_0_tasksComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const ADM_OUT_0_tasks = compose(
  withConnect,
  withRouter,
)(ADM_OUT_0_tasksComp);
